class NovaB2BMinimumValidator extends HTMLElement {
  constructor() {
    super();
    this.checkoutButton = null;
    this.noticeElement = null;
    this.minimumAmount = null;
    this.init();
  }

  init() {
    this.checkoutButton = document.querySelector("[data-nova-b2b-checkout-button]");

    if (!this.checkoutButton) {
      console.warn("NovaB2BMinimumValidator: Checkout button not found");
      return;
    }

    this.minimumAmount = parseFloat(this.checkoutButton.dataset.novaB2bMinimumAmount);

    if (!this.minimumAmount) {
      return;
    }

    this.noticeElement = this.querySelector(".nova-b2b-minimum-notice");

    this.checkoutButton.addEventListener("click", this.handleCheckoutClick.bind(this));
  }

  handleCheckoutClick(event) {
    const cartTotal = this.getCartTotal();

    if (cartTotal < this.minimumAmount) {
      event.preventDefault();
      event.stopPropagation();

      this.showMinimumNotice();
    } else {
      this.hideMinimumNotice();
    }
  }

  getCartTotal() {
    // Get cart total from the data-cart-subtotal element
    const cartTotalElement = document.querySelector("[data-cart-subtotal]");

    if (!cartTotalElement) {
      console.error(
        "NovaB2BMinimumValidator: Element with data-cart-subtotal attribute is missing. Please add data-cart-subtotal to the cart total element in your Liquid template.",
      );
      return 0;
    }

    const totalText = cartTotalElement.textContent.trim();
    // Extract numeric value from currency string
    const numericValue = parseFloat(totalText.replace(/[^\d.,]/g, "").replace(",", "."));

    if (isNaN(numericValue)) {
      console.error("NovaB2BMinimumValidator: Could not parse cart total value:", totalText);
      return 0;
    }

    return numericValue;
  }

  showMinimumNotice() {
    if (this.noticeElement) {
      this.noticeElement.style.display = "block";
    }
  }

  hideMinimumNotice() {
    if (this.noticeElement) {
      this.noticeElement.style.display = "none";
    }
  }

  refresh() {
    // Hide notice when cart is updated, it will show again on next checkout attempt if needed
    this.hideMinimumNotice();
  }
}

customElements.define("nova-b2b-minimum-validator", NovaB2BMinimumValidator);
